import { render } from "./MyImagemFullStack.vue?vue&type=template&id=47fd4d88&scoped=true&ts=true"
import script from "./MyImagemFullStack.vue?vue&type=script&lang=ts"
export * from "./MyImagemFullStack.vue?vue&type=script&lang=ts"

import "./MyImagemFullStack.vue?vue&type=style&index=0&id=47fd4d88&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fd4d88"]])

export default __exports__